module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_redefine.js
// module id = 52
// module chunks = 0 1 2 3 4 5 6 7 8 9 10